<div class="dashboard-content-sec page-col user-filter-space">
    <div class="loader" *ngIf="showloader">
        <img src="assets/images/loader.gif" alt="">
    </div>
    
    <div id="greeting" class="">
        <div id="hello">
            <span>{{title}}</span>
        </div>
    </div>

    <div class="mt-0 d-block">

        <div id="page-tabs" class="d-block">
            <ng-container *ngFor="let page of pages; let i = index">
                <div (click)="selectMe($event)" data-toggle="collapse" id="menu-page{{page.ID}}"
                   [attr.data-target]="'page'+ page.ID"  [ngClass]="(selectedPage === page.ID)? 'selected tab': 'tab'">
                    {{ page.Name }}
                </div>
            </ng-container>
        </div>

        <ng-container *ngFor="let page of pages; let i = index">
            <div id="page{{page.ID}}" class="page-title sub-menu collapse">
                {{page.Name}}
                <div class="d-block mt-0">
                    <ng-container *ngFor="let post of posts | postFilter: page.ID">                    
                        <div class="tab2" id="menu-post{{post.ID}}" (click)="selectPost($event)" data-toggle="collapse" 
                           [attr.data-target]="'post' + post.ID" [ngClass]="(selectedPost === post.ID)? 'selected tab2': 'tab2'">  
                            {{post.Name}}
                        </div>
                    </ng-container>                
                </div>
            </div>
        </ng-container>

        <ng-container *ngFor="let page of pages; let i = index">
            <ng-container *ngFor="let post of posts | postFilter: page.ID">                    
                <div id="post{{post.ID}}" class="post collapse">
                    <!-- Text -->
                    <div class='post-text post-body d-block' *ngIf="post.Style === 1">
                        <div [innerHTML]="post.Body"></div>
                    </div>               

                    <!-- Training -->
                    <div class='post-body d-block' *ngIf="post.Style === 2">
                        <div class="post-text" [innerHTML]="post.Body"></div>                   
                        <div train-container>
                            <div class="header mb-2">Training Videos</div>
                            <div class="train hrmenu-box">
                                <div class="train-inner">
                                    <div class="train-but" id="train-{{post.ID}}-{{train.id}}" 
                                         *ngFor="let train of post.trainTable" (click)="openTrain(post.ID, train.id)">
                                        <div class="oval">
                                            <div class="triangle">
                                            </div>
                                        </div>
                                        <div class="train-title">
                                            {{train.title}}
                                        </div>
                                        <div class="train-overview">
                                            {{train.overview}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>               

                    <!-- FAQ's -->
                    <div class='post-body d-block' *ngIf="post.Style === 3">
                        <div class="post-text" [innerHTML]="post.Body"></div>
                        <div faq-container>
                            <div class="header mb-2">FAQ's</div>
                            <div class="faq hrmenu-box">
                                <div class="faq-inner">
                                    <div class="faq-but" *ngFor="let faq of post.faqTable">
                                        <div class="faq-question">
                                            <span>Q.</span><br/>
                                            {{faq.question}}
                                        </div>
                                        <div id="faq-partial-{{post.ID}}-{{faq.id}}" class="faq-answer collapse show">
                                            <span>A.</span><br/>
                                            {{faq.partialAnswer}}
                                            <a (click)="openFaq(post.ID,faq.id)" *ngIf="faq.continue">   Continue reading...</a>
                                        </div>
                                        <div id="faq-full-{{post.ID}}-{{faq.id}}" class="faq-answer-full collapse">
                                            <span>A.</span><br/>
                                            {{faq.answer}}
                                            <a (click)="closeFaq(post.ID,faq.id)">Collapse</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>               

                     <!-- Resouces and Forms -->
                    <div class='post-body d-block' *ngIf="post.Style === 4">
                        <div class="post-text" [innerHTML]="post.Body"></div>
                        <div class="section d-block" *ngFor="let section of post.sectionTable">
                            <div class="resource-container" *ngIf="section.style==='1'">
                                <div class="header">{{section.title}}</div>
                                <div class="resource hrmenu-box">
                                    <div class="resource-doc doc-but" (click)="openDoc(doc.docId)" *ngFor="let doc of section.docs">
                                        {{doc.name}}
                                    </div>
                                </div>
                            </div>
                            <div class="forms-container" *ngIf="section.style==='2'">
                                <div class="header">{{section.title}}</div>
                                <div class="forms hrmenu-box">
                                    <div class="d-block" *ngFor="let subsect of section.subsects; let i = index">
                                        <div class="header form-divider" *ngIf="(i > 0)">
                                            <a data-target="#doc-sect-{{post.ID}}-{{subsect.id}}" data-toggle="collapse"
                                               (click)="openClose(post.ID, subsect.id )">
                                                {{subsect.title}}
                                            </a>
                                        </div>
                                        
                                        <div id="doc-sect-{{post.ID}}-{{subsect.id}}" [ngClass]="subsect.collapse === '1'? 'collapse': 'collapse show'">
                                            <div class="forms-doc doc-but" 
                                                (click)="openDoc(doc.docId)" *ngFor="let doc of subsect.docs">
                                                {{doc.name}}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>   
                    
                    <!-- Overview style -->
                    <div class='post-body d-block' *ngIf="post.Style === 5">
                        <div class="overview">
                            <div [innerHTML]="post.Body"></div>
                        </div>

                        <div class="over-resource" >
                            <div class="header">Resources and Forms</div>
                            <div class="resource hrmenu-box">
                                <div class="resource-doc doc-but" (click)="openDoc(doc.docId)" *ngFor="let doc of post.overviewTable">
                                    {{doc.name}}
                                </div>
                            </div>
                        </div>
                    </div>               
                </div>
            </ng-container>
        </ng-container>


        <!-- <ng-container *ngFor="let page of pages; let i = index">

            <div class="col-md-4">
                <div class="card hide-overflow">
                    <div class="card-body">
                        <a data-toggle="collapse" href="#{{page.href}}">
                            <h5 class="text-center card-title">{{page.Name}}</h5></a>
                        <div class="card-body text-center">
                            <div class="btn-group-vertical text-center" class="collapse"  id="{{page.href}}">
                                <div style="display:grid">
                                    <a href="javascript:void(0)" [routerLink]="['/show-page',post.ID]" 
                                    class="btn btn-light" *ngFor="let post of posts | callback: page.ID:filterPost">
                                        {{post.Name}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </ng-container> -->
    </div>

</div>